import { render, staticRenderFns } from "./ContinuousColorSettings.vue?vue&type=template&id=79511a4c"
import script from "./ContinuousColorSettings.vue?vue&type=script&lang=js"
export * from "./ContinuousColorSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports